import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useProblems() {
  const [problems, setProblems] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);
  useEffect(() => {
    supabase.from('problems')
      .select('id,title,date,difficulty,tags,slug,summary')
      .order('date_iso', { ascending: false })
      .then(({ data, error }) => {
        if (error) setError(error.message);
        else setProblems(data || []);
        setLoading(false);
      });
  }, []);
  return { problems, loading, error };
}
